// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b4f67456","453":"1f271b29"}[chunkId] + ".chunk.js";
};